
<div class="container">

<br>
<br>
  <form [formGroup]="activationForm">
    <ng-container *ngIf="this.url ==='user-block' || this.url ==='user-unblock' " class="box">
      <h6 class="user-func" *ngIf="this.url ==='user-block' "><em class="fa fa-chevron-circle-left" (click)="goBack()"></em>&nbsp; <span>Block User</span></h6>
      <h6 class="user-func" *ngIf="this.url ==='user-unblock' "><em class="fa fa-chevron-circle-left" (click)="goBack()"></em>&nbsp; <span>Unblock User</span></h6>
       <div class="box">
        <div>
          <label for="comments">{{'Description' | translate}}&nbsp;<span class="text-danger">*</span></label>
          <textarea id="comments" type="text" formControlName="comments" class="form-control"
            [ngClass]="{ 'is-invalid': isSubmitted && activationForm.get('comments')?.errors }"></textarea>
          <div *ngIf="isSubmitted && activationForm.get('comments')?.errors?.required" class="text-danger">
            {{'description_required' | translate}}
          </div>
        </div>
        <br>
        <br>
        <div *ngIf="this.url ==='user-block'">
          <input id="block" type="checkbox" formControlName="block"
            [ngClass]="{ 'is-invalid': isSubmitted && activationForm.get('block')?.errors }">
          <label for="block" class="ms-1">{{'confirm_block_check' | translate}}</label>
          <div *ngIf="isSubmitted && activationForm.get('block')?.errors?.required" class="text-danger">
            {{'confirm_block' | translate}}
          </div>
        </div>
        <div *ngIf="this.url ==='user-unblock'">
          <input id="unBlock" type="checkbox" formControlName="unBlock"
            [ngClass]="{ 'is-invalid': isSubmitted && activationForm.get('unBlock')?.errors }">
          <label for="unBlock" class="ms-1">{{'confirm_unblock_check' | translate}}</label>
          <div *ngIf="isSubmitted && activationForm.get('unBlock')?.errors?.required" class="text-danger">
           {{'confirm_unblock' | translate}}
          </div>
        </div>
        <br>
       </div>
    </ng-container>
    

    <ng-container *ngIf="this.url === 'user-unlock'">
      <h6 class="user-func"><em class="fa fa-chevron-circle-left" (click)="goBack()"></em>&nbsp; <span>{{'unlock_user' | translate}}</span></h6>
       <div class="box">
        <div>
          <label for="unlockComments">{{'comments' | translate}}&nbsp;<span class="text-danger">*</span></label>
          <textarea id="unlockComments" type="text" formControlName="unlockComments" class="form-control"
            [ngClass]="{ 'is-invalid': isSubmitted && activationForm.get('unlockComments')?.errors }"></textarea>
          <div *ngIf="isSubmitted && activationForm.get('unlockComments')?.errors?.required" class="text-danger">
            {{'Enter_commentsRequired' | translate}}
          </div>
        </div>
        <br>
        <br>
        <div>
          <input id="unlock" type="checkbox" formControlName="unlock"
            [ngClass]="{ 'is-invalid': isSubmitted && activationForm.get('unlock')?.errors }">
          <label for="unlock" class="ms-1">{{'unlock_confirmation' | translate}}</label>
          <div *ngIf="isSubmitted && activationForm.get('unlock')?.errors?.required" class="text-danger">
           {{'unlock_confirmation_check' | translate}}
          </div>
        </div>
        <br>
       </div>
    </ng-container>
    

    <ng-container *ngIf="this.url === 'user-deactivate'" >
      <h6 class="user-func"><em class="fa fa-chevron-circle-left" (click)="goBack()"></em>&nbsp; <span>{{'deactivate_user' | translate}}</span></h6>
        <div class="box">
          <div>
            <label for="deactivateComments">&nbsp;{{'comments' | translate}}<span class="text-danger">*</span></label>
            <textarea id="deactivateComments" type="text" formControlName="deactivateComments" class="form-control"
              [ngClass]="{ 'is-invalid': isSubmitted && activationForm.get('deactivateComments')?.errors }"></textarea>
            <div *ngIf="isSubmitted && activationForm.get('deactivateComments')?.errors?.required" class="text-danger">
              {{'Enter_commentsRequired' | translate}}
            </div>
          </div>
          <br>
          <br>
          <div>
            <input id="deactivate" type="checkbox" formControlName="deactivate"
              [ngClass]="{ 'is-invalid': isSubmitted && activationForm.get('deactivate')?.errors }">
            <label for="deactivate" class="ms-1">{{'confirm_deactivate' | translate}}</label>
            <div *ngIf="isSubmitted && activationForm.get('deactivate')?.errors?.required" class="text-danger">
             {{'confirm_deactivate_check' | translate}}
            </div>
          </div>
        </div>
      <br>
    </ng-container>
    
    <div class="text-center mt-3">
    <button class="btn btnc me-1" (click)="onSubmit(url)"><em class={{iconClass}}></em>
      {{btnLabel}}</button>
    </div>
  </form>
</div>
